const getColorLatency = (code: number) => {
  if (code >= 0 && code < 200) return 'green';
  if (code >= 200 && code < 400) return 'gold';
  if (code) return 'red';
  return '';
};

export default getColorLatency;
